/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SubscriptionPromocodeDto } from '../models';
/**
 * SubscriptionPromocodeApi - axios parameter creator
 * @export
 */
export const SubscriptionPromocodeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [promocode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionPromocodeGet: async (promocode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/subscription/promocode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (promocode !== undefined) {
                localVarQueryParameter['promocode'] = promocode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionPromocodeApi - functional programming interface
 * @export
 */
export const SubscriptionPromocodeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionPromocodeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [promocode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSubscriptionPromocodeGet(promocode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionPromocodeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSubscriptionPromocodeGet(promocode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubscriptionPromocodeApi.apiSubscriptionPromocodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubscriptionPromocodeApi - factory interface
 * @export
 */
export const SubscriptionPromocodeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionPromocodeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [promocode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSubscriptionPromocodeGet(promocode?: string, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionPromocodeDto> {
            return localVarFp.apiSubscriptionPromocodeGet(promocode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionPromocodeApi - object-oriented interface
 * @export
 * @class SubscriptionPromocodeApi
 * @extends {BaseAPI}
 */
export class SubscriptionPromocodeApi extends BaseAPI {
    /**
     * 
     * @param {string} [promocode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionPromocodeApi
     */
    public apiSubscriptionPromocodeGet(promocode?: string, options?: RawAxiosRequestConfig) {
        return SubscriptionPromocodeApiFp(this.configuration).apiSubscriptionPromocodeGet(promocode, options).then((request) => request(this.axios, this.basePath));
    }
}

